const cacheKey = 'hideInfoBox';

export function isHidden(infoBox: { id: string }) {
  if (!infoBox?.id) return true;
  if (window.navigator.userAgent.indexOf('DataTrue') > -1) return true;

  try {
    const dismissed = localStorage.getItem(cacheKey);
    if (!dismissed) return false;

    if (dismissed === 'true') {
      localStorage.removeItem(cacheKey);
      hide(infoBox);
      return true;
    }
    return dismissed.includes(infoBox.id);
  } catch {
    return false;
  }
}

export function hide(infoBox: { id: string }) {
  try {
    const dismissed = `${localStorage.getItem(cacheKey) || ''} ${infoBox.id}`;
    localStorage.setItem(cacheKey, dismissed);
  } catch {
    // oh well
  }
}

export function clear() {
  try {
    localStorage.removeItem(cacheKey);
  } catch (error) {
    // nevermind
  }
}
